var parent = require('../../es/array');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// /tmp/build_310c34ba/node_modules/core-js/stable/array/index.js
// module id = 424
// module chunks = 2